import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {

  MenuItem,

} from '@mui/material';

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { MaterialReactTable } from "material-react-table";
import Swal from 'sweetalert2';

// Reusable status toggle button component
const StatusToggleButton = ({ id, active, onToggle }) => (
  <button
    className={`btn btn-sm ${active ? "btn-success" : "btn-danger"}`}
    onClick={() => onToggle(id, active)}
  >
    {active ? "Default Season" : "Inactive Season"}
  </button>
);

StatusToggleButton.propTypes = {
  id: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};
import FindModuleById from '.././FindModuleById';

// Main component
const Season = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
        const [permission, setPermission] = useState({});

  useEffect(() => {

     setPermission(FindModuleById(451)); 
    axios
      .post(
        "/settings-seasons/listing",
        {},
        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setData(response.data.data.seasons);
        } else {
          window.location.href = "/login";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const handleStatusToggle = (id, currentStatus) => {
        Swal.fire({
          title: 'Do you really want to update the season?',
          icon: 'success',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Update'
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post(
              "/settings-seasons/change-status",
              { id, active: !currentStatus },
              {
                headers: {
                  Authorization: `Bearer ${Authtoken}`,
                  Apitoken: Apitoken,
                },
              }
            ).then((response) => {
              if (response.data.code === 200) {
                setData(response.data.data.seasons);
                let active_season = response.data.data.active_season;
                localStorage.setItem("season_id", active_season.id);
                localStorage.setItem("season_name", active_season.name);
                localStorage.setItem("season_start", active_season.start);
                localStorage.setItem("season_end", active_season.end);
                localStorage.setItem("all_seasons", JSON.stringify(response.data.data.seasons));

              } else {
                alert("Failed to update status");
              }
            }) .catch((error) => {
              console.error(error);
              alert("Error updating status");
            });
          
          
          }});
   
  };

  const StatusCell = ({ row, onToggle }) => (
    <StatusToggleButton
      id={row.original.id}
      active={row.original.status}
      onToggle={onToggle}
    />
  );

  StatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.number.isRequired,
        status: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
    onToggle: PropTypes.func.isRequired,
  };

  const StatusCellWrapper = ({ row }) => (
    <StatusCell row={row} onToggle={handleStatusToggle} />
  );

  StatusCellWrapper.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.number.isRequired,
        status: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
  };

  const columns = [
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "start",
      header: "Start",
    },
    {
      accessorKey: "end",
      header: "End",
    },
    {
      header: "Status",
      accessorFn: (row) => row.status,
      Cell: StatusCellWrapper,
    },
    {
      header: "Created By",
      accessorFn: (row) =>
        row.createdby
          ? `${row.createdby.first_name} ${row.createdby.last_name}`
          : "",
    },
  ];


const editItem = (item)=>{
  window.location.href = "/seasons-edit/"+item;
}

  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={toggleMobileMenu} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Seasons</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Seasons</li>
                </ul>
              </div>
              <div className="col-auto">
                {/* <Link to="/seasons-add" className="btn btn-primary me-1">
                  <i className="fas fa-plus"></i>
                </Link> */}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {permission && permission.add == 1 && (
                     <div className="table-responsive">
                    <MaterialReactTable
                      columns={columns}
                      data={data}
                      enableColumnOrdering
                    // enableGrouping
                    enablePinning
                    enableRowActions
                    // enableRowSelection
                    // initialState={{ showColumnFilters: true }}
                   
                    renderRowActionMenuItems={({ row }) => [
                      <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                        Edit
                      </MenuItem>
                    ]}
                    />
                  </div>
                   )}
                 
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Season;
